import {FC} from 'react'
import {ActionColumn, CanDeleteProp, CanEditProp, CanReadProp} from '../types'
import ActionDropdown from './Dropdown'
import ActionButton from './Button'

type Props = {
  column: ActionColumn
  row: any
  canRead?: CanReadProp
  canEdit?: CanEditProp
  canDelete?: CanDeleteProp
  canAdd?: string
  // onDelete: (row: Object) => void
}

const Actions: FC<Props> = ({column, row, canRead, canEdit, canDelete}) => {
  const maxActions = Math.min(column.actions.length, column?.maxActions ?? 3)
  const actions = []
  const moreActions = []

  for (let idx = 0; idx < column.actions.length; idx++) {
    const action = column.actions[idx]

    if (action.type === 'view') {
      let link = undefined

      if (typeof canRead === 'string') {
        link = canRead
      } else if (typeof canRead === 'function') {
        link = canRead(row)
      }
      if (!link) continue

      const act = {
        to: link,
        ...action,
      }

      if (idx < maxActions) actions.push(<ActionButton action={act} row={row} key={idx} />)
      else moreActions.push(act)
    } else if (action.type === 'edit') {
      let link = undefined

      if (typeof canEdit === 'string') {
        link = canEdit
      } else if (typeof canEdit === 'function') {
        link = canEdit(row)
      }

      if (!link) continue

      const act = {
        to: link,
        ...action,
      }

      if (idx < maxActions) actions.push(<ActionButton action={act} row={row} key={idx} />)
      else moreActions.push(act)
    } else if (action.type === 'delete') {
      if (!canDelete) continue
      let render = undefined
      if (typeof canDelete === 'function') {
        render = canDelete(row)
      } else {
        render = canDelete
      }
      if (!render) continue

      if (idx < maxActions) actions.push(<ActionButton action={action} row={row} key={idx} />)
      else moreActions.push(action)
    } else if (
      action.type === 'custom' &&
      !(typeof action.hide === 'function' ? action.hide(row) : action.hide)
    ) {
      if (idx < maxActions) actions.push(<ActionButton action={action} row={row} key={idx} />)
      else moreActions.push(action)
    }
  }

  return (
    <>
      {column.component && column.component(row, column)}
      {actions}
      {moreActions.length > 0 && <ActionDropdown actions={moreActions} row={row} />}
    </>
  )
}

export default Actions
